package com.rosario.juridico.marketplace.model

import kotlinx.datetime.Clock
import kotlinx.datetime.Instant
import kotlinx.serialization.Serializable

@Serializable
data class Consulta(
    val id: String = "",
    val userId: String = "",
    val categoria: String? = null,
    val descripcion: String = "",
    val urgencia: String = "Media",
    val ubicacion: String = "Rosario",
    val telefono: String = "",
    val estado: String = "pendiente",
    val motivoRechazo: String? = null,
    val fecha: Instant = Clock.System.now(),
    val tipoConsulta: String = "cliente",
    val subtipoB2B: String? = null,
    val jurisdiccionDestino: String? = null,
    val modalidadHonorarios: String? = null
)

@Serializable
data class Propuesta(
    val id: String = "",
    val consultaId: String = "",
    val abogadoId: String = "",
    val abogadoNombre: String = "",
    val mensaje: String = "",
    val honorarios: Double = 0.0,
    val fecha: Instant = Clock.System.now()
)

@Serializable
enum class NivelVerificacion {
    NIVEL_1_CREADA,
    NIVEL_2_PENDIENTE,
    NIVEL_3_VERIFICADO
}

@Serializable
data class Abogado(
    val id: String = "",
    val nombre: String = "",
    val apellido: String = "",
    val email: String = "",
    val telefono: String? = "",
    val matricula: String? = "",
    val especialidades: List<String> = emptyList(),
    val zona: String = "",
    val calificacion: Double = 5.0,
    val casosExitosos: Int = 0,
    val isSubscribed: Boolean = false,
    val subscriptionExpiry: String? = null,
    val isAdmin: Boolean = false,
    val nivelVerificacion: String = NivelVerificacion.NIVEL_1_CREADA.name
)

// ── Expediente jurídico expandido ─────────────────────────────────────────────
@Serializable
data class Expediente(
    val id: String = "",
    val caratula: String = "",
    val estadoProcesal: String = "",
    val fechaCreacion: Long = 0L,
    val archivado: Boolean = false,
    // Campos jurídicos adicionales
    val cliente: String = "",
    val fuero: String = "",           // Civil, Laboral, Penal, Familia, Comercial, Contencioso, Otro
    val juzgado: String = "",
    val nroExpediente: String = "",   // Número de expediente judicial
    val prioridad: String = "Normal", // Alta, Normal, Baja
    val observaciones: String = ""
)

// ── Movimiento procesal ────────────────────────────────────────────────────────
@Serializable
data class Movimiento(
    val id: String = "",
    val expedienteId: String = "",
    val tipo: String = "",            // Demanda, Contestación, Audiencia, Cédula, Oficio, etc.
    val descripcion: String = "",
    val fecha: Long = 0L,
    val fechaVencimiento: Long? = null,
    val juzgado: String = "",
    val observaciones: String = "",
    val completado: Boolean = false,
    val creadoEn: Long = 0L
)

// ── Tarea (compatible con estructura anterior) ────────────────────────────────
@Serializable
data class Tarea(
    val id: String = "",
    val descripcion: String = "",
    val fechaVencimiento: Long? = null,
    val completada: Boolean = false
)

// ── Categorías de movimientos procesales ─────────────────────────────────────
object TiposMovimiento {
    val todos = listOf(
        "Demanda",
        "Contestación",
        "Audiencia",
        "Cédula",
        "Oficio",
        "Apelación",
        "Decreto",
        "Sentencia",
        "Mediación",
        "Ejecución",
        "Escrito",
        "Pericia",
        "Traslado",
        "Vista",
        "Otro"
    )
}

// ── Fueros judiciales (Santa Fe) ──────────────────────────────────────────────
object FuerosJudiciales {
    val todos = listOf(
        "Civil y Comercial",
        "Laboral",
        "Penal",
        "Familia",
        "Contencioso Administrativo",
        "Ejecución Fiscal",
        "Concursos y Quiebras",
        "Otro"
    )
}

// ── Estados procesales predefinidos ──────────────────────────────────────────
object EstadosProcesales {
    val todos = listOf(
        "Inicio / Consulta",
        "Interposición de demanda",
        "Traslado de demanda",
        "Contestación de demanda",
        "Período de prueba",
        "Alegatos",
        "Sentencia de primera instancia",
        "Apelación",
        "Sentencia de segunda instancia",
        "Ejecución de sentencia",
        "Mediación prejudicial",
        "Conciliación",
        "Archivo",
        "Otro"
    )
}
